import {
  useEffect, useContext, useMemo,
} from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';

import useCachedCMSDataTreatment from 'hooks/useCachedCMSDataTreatment';
import useIsEventClosedMemo from 'hooks/useIsEventClosedMemo';
import { UserSessionContext } from 'components/UserSession';
import { SplitioContext } from 'components/SplitioContext';
import { selectLocale } from 'models/localization';
import { fetchBoothTaxonomies } from 'models/cms/boothTaxonomies';
import { fetchBoothTiers } from 'models/cms/boothTiers';
import { fetchQuestions } from 'models/questions';

const useCMSDataEffect = () => {
  const dispatch = useDispatch();
  const locale = useSelector(selectLocale);
  const { userSession } = useContext(UserSessionContext);
  const authToken = useMemo(() => (userSession || {}).authToken, [userSession]);
  const { features } = useSelector((s: any) => s.eventConfigs);
  const supportHktdcFiltering = useMemo(() => features.includes('hktdcFiltering'), [features]);
  const { isReady: isSplitioReady } = useContext(SplitioContext);
  const cachedCMSData = useCachedCMSDataTreatment();
  const isEventClosed = useIsEventClosedMemo();

  useEffect(() => {
    if (isEventClosed) {
      return;
    }

    if (authToken && isSplitioReady && !cachedCMSData) {
      batch(() => {
        dispatch(fetchBoothTaxonomies({}));
        dispatch(fetchBoothTiers({}));
      });
    }
    if (supportHktdcFiltering) {
      dispatch(fetchQuestions());
    }
  }, [
    dispatch,
    isEventClosed,
    authToken,
    cachedCMSData,
    isSplitioReady,
    locale,
    supportHktdcFiltering,
  ]);
};

export default useCMSDataEffect;
